import { RequestStatus } from './types';
import { reduxKey } from './constants';
function getState(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
export const getIsReduxLoaded = (state)=>getState(state).isReduxLoaded;
export const getDisplayData = (state, displayId)=>{
    var _getState_displays;
    return (_getState_displays = getState(state).displays) === null || _getState_displays === void 0 ? void 0 : _getState_displays[displayId];
};
export const getIsDisplayInitialized = (state, displayId)=>!!getDisplayData(state, displayId);
var _getDisplayData_actualPrice;
export const getActualPrice = (state, displayId)=>{
    var _getDisplayData;
    return (_getDisplayData_actualPrice = (_getDisplayData = getDisplayData(state, displayId)) === null || _getDisplayData === void 0 ? void 0 : _getDisplayData.actualPrice) !== null && _getDisplayData_actualPrice !== void 0 ? _getDisplayData_actualPrice : 0;
};
var _getDisplayData_earnings;
export const getEstimatedEarnings = (state, displayId)=>{
    var _getDisplayData;
    return (_getDisplayData_earnings = (_getDisplayData = getDisplayData(state, displayId)) === null || _getDisplayData === void 0 ? void 0 : _getDisplayData.earnings) !== null && _getDisplayData_earnings !== void 0 ? _getDisplayData_earnings : 0;
};
var _getDisplayData_requestInfo;
export const getRequestInfo = (state, displayId)=>{
    var _getDisplayData;
    return (_getDisplayData_requestInfo = (_getDisplayData = getDisplayData(state, displayId)) === null || _getDisplayData === void 0 ? void 0 : _getDisplayData.requestInfo) !== null && _getDisplayData_requestInfo !== void 0 ? _getDisplayData_requestInfo : {
        status: RequestStatus.Idle
    };
};
export const getServiceFeePercent = (state, displayId)=>{
    var _getDisplayData;
    return (_getDisplayData = getDisplayData(state, displayId)) === null || _getDisplayData === void 0 ? void 0 : _getDisplayData.serviceFeePercentage;
};
